import { useEffect, useState } from "react";
import { handleData } from "../../api";
import { fullName } from "../../helperfunctions/helperfunctions";

const AdminNewOrEditTaak = (props) => {

    const { taak= {}, activiteitID, editStatus, setEditStatus, mode, closeActiviteitForm } = props;
    const { _id="", taaknaam="", taakomschrijving="", dagdeel="", contactpersoon=""} = taak;

    const initialFormData = {
        taaknaam,
        taakomschrijving,
        dagdeel,
        contactpersoon
    }

    const [formData, setFormData] = useState(initialFormData);
    const [contactPersonen, setContactPersonen] = useState([]);

    const getContactPersonen = async() => {
        const data = {
            method: 'GET',
            path: 'users'
        }
        const result = await handleData(data);
        if (result.data.data) {
            const contactpersonenArray = result.data.data.filter(item => item.contactpersoon);
            const contactPersonenNames = contactpersonenArray.map(item => {
                return {
                    _id: item._id,
                    naam: fullName(item)
                }
            })
            setContactPersonen(contactPersonenNames);
        } else {
            console.log("contactpersonen niet geladen");
        }
    }



    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name] : e.target.value
        })
    };

    const handleSubmit = async (e) => {
        !formData.contactpersoon && delete formData.contactpersoon;
        e.preventDefault();
        if (mode === "new") {
            const path = `activiteiten/${activiteitID}/newtaak`
            const data = {
                method: 'PATCH',
                path: path,
                input: formData
            }
            const newTaak = await handleData(data);

            setFormData(initialFormData);
            setEditStatus({
                ...editStatus,
                addTaak: false,
                editTaak: false,
                editID: ""
            });
            closeActiviteitForm(true);
    
        } else if(mode === "edit") {
            const path = `activiteiten/${activiteitID}/taken/${_id}`;
            const input = {
                'taken.$.taaknaam': formData.taaknaam,
                'taken.$.taakomschrijving': formData.taakomschrijving,
                'taken.$.dagdeel': formData.dagdeel,
                'taken.$.contactpersoon': formData.contactpersoon
            }
            !formData.contactpersoon && delete input['taken.$.contactpersoon'];

            const data = {
                method: 'PATCH',
                path: path,
                input: input
            };
            const editedTaak = await handleData(data);

            setFormData(initialFormData);
            setEditStatus({
                ...editStatus,
                taakEdit: false,
                taakEditID: ""
            });
            closeActiviteitForm(true);
        }
    }

    const handleCloseForm = (e) => {
        e.preventDefault();
        setFormData(initialFormData);
        setEditStatus({
            ...editStatus,
            addTaak: false,
            editTaak: false,
            editID: ""
        });
    }

    useEffect(() => {
        getContactPersonen();
    },[]);

    return (
        <>
            <div className= "newTaakContainer">
                <form onSubmit={handleSubmit}>
                    <div>
                        <p>taak naam:</p>
                        <input 
                            type="text" 
                            name="taaknaam"
                            value={formData.taaknaam}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <p>taak omschrijving:</p>
                        <textarea 
                            cols="40"
                            rows="5" 
                            name="taakomschrijving"
                            value={formData.taakomschrijving}
                            onChange={handleChange}
                        >
                        </textarea>
                    </div>
                    <div>
                        <p>dagdeel:</p>
                        <input 
                            type="text" 
                            name="dagdeel"
                            value={formData.dagdeel}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <p>Contactpersoon:</p>

                        <select 
                            name="contactpersoon" 
                            id="contactpersoon" 
                            onChange={handleChange}
                            value={formData.contactpersoon._id}
                        >
                            <option value="" >Selecteer een contactpersoon</option>
                            {contactPersonen.map(item => {
                                return <option key={item._id} value={item._id}>{item.naam}</option>
                            })}
                        </select>

                    </div>

                    <div>
                        <button>Submit</button>
                        <button onClick={handleCloseForm}>Cancel</button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default AdminNewOrEditTaak;